export default __webpack_public_path__ + "static/media/Duvalli, S.A.5d2b2523.jpg";